// Auth utility functions

// Non-React module: read the stored language directly for user-facing alerts.
const sessionExpiredMsg = () => (localStorage.getItem('k360-lang') === 'en'
  ? 'Your session has expired. Please sign in again.'
  : 'Sesioni ka skaduar. Ju lutem hyni përsëri.');

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return null;
  }
  
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const handleAuthError = (response) => {
  if (response.status === 401) {
    alert(sessionExpiredMsg());
    localStorage.removeItem('token');
    window.location.href = '/';
    return true;
  }
  return false;
};

export const checkAuthToken = () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    alert(sessionExpiredMsg());
    window.location.href = '/';
    return false;
  }
  
  return true;
};

export const isTokenExpired = () => {
  const token = localStorage.getItem('token');
  
  if (!token) return true;
  
  try {
    // Decode JWT token (without verification - just to check expiry)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= exp;
  } catch (err) {
    console.error('Failed to decode token:', err);
    return true;
  }
};

export const logout = (showMessage = true) => {
  const wasLoggedIn = !!localStorage.getItem('token');
  localStorage.removeItem('token');
  
  // Only show message if user was actually logged in (session expired)
  if (wasLoggedIn && showMessage) {
    // Store message to show on login page
    sessionStorage.setItem('sessionExpired', 'true');
  }
  
  window.location.href = '/';
};

